import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2, Download } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const LABEL = { restock: 'Stock in', adjustment: 'Count / adjustment', past_purchase: 'Purchase recorded', create: 'Item added' };
const fmt = (iso) => new Date(iso).toLocaleString('en-US', { timeZone: 'America/Los_Angeles', month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' });
const csvCell = (v) => `"${String(v ?? '').replace(/"/g, '""')}"`;

export default function InventoryActivityTab({ headers }) {
  const [rows, setRows] = useState(null);
  useEffect(() => { axios.get(`${API_URL}/api/admin/inventory/activity`, { headers }).then((r) => setRows(r.data)).catch(() => setRows(false)); }, [headers]);
  const exportCsv = () => {
    const head = ['Date (PT)', 'Item', 'Action', 'Quantity change', 'Amount paid', 'Reason / notes', 'By'];
    const body = rows.map((a) => [fmt(a.created_at), a.item_name, LABEL[a.txn_type] || a.txn_type, a.quantity_delta, a.amount_paid ?? '', a.reason || a.notes || '', a.actor_name]);
    const blob = new Blob([[head, ...body].map((r) => r.map(csvCell).join(',')).join('\n')], { type: 'text/csv' });
    const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'inventory-activity.csv'; a.click();
  };
  if (rows === null) return <Loader2 className="h-5 w-5 animate-spin text-[#f36a19]" />;
  if (rows === false) return <p className="text-sm text-[#a4471b]">Activity could not be loaded.</p>;
  return (
    <section className="rounded-[10px] border border-[#e7e4db] bg-[#fffefa]" data-testid="inventory-activity">
      <div className="flex items-center justify-between px-5 py-4 border-b border-[#ecebe4]">
        <p className="text-sm text-[#5f6455]">Every stock movement, count and purchase, newest first.</p>
        <button onClick={exportCsv} disabled={!rows.length} className="text-xs font-semibold text-[#b75b28] inline-flex items-center gap-1" data-testid="inventory-activity-export"><Download className="h-3.5 w-3.5" /> Export CSV</button>
      </div>
      {rows.length === 0 ? <p className="p-5 text-sm text-[#77776e]">No activity yet.</p> : (
        <ul className="divide-y divide-[#ecebe4]">
          {rows.map((a) => (
            <li key={a.id} className="px-5 py-3 flex flex-wrap gap-x-5 gap-y-1 text-sm" data-testid={`inventory-activity-${a.id}`}>
              <span className="w-40 text-xs text-[#77776e]">{fmt(a.created_at)} PT</span>
              <span className="flex-1 min-w-[200px] text-[#20211d]"><b>{a.item_name}</b> · {LABEL[a.txn_type] || a.txn_type}{(a.reason || a.notes) ? <span className="block text-xs text-[#77776e]">{a.reason || a.notes}</span> : null}</span>
              <span className={`text-xs font-semibold ${a.quantity_delta > 0 ? 'text-[#55704a]' : a.quantity_delta < 0 ? 'text-[#a4471b]' : 'text-[#5f6455]'}`}>{a.quantity_delta > 0 ? '+' : ''}{a.quantity_delta}</span>
              {a.amount_paid != null && <span className="text-xs text-[#5f6455]">${Number(a.amount_paid).toFixed(2)}</span>}
              <span className="text-xs text-[#8a8c80]">{a.actor_name}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
